import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import SEO from "../components/SEO";
import api from "../api";
import HeroSection from "../sections/HeroSection";
import FeaturedArtworksSection from "../sections/FeaturedArtworksSection";
import CallToActionSection from "../sections/CallToActionSection";
import StudioSection from "../sections/StudioSection";
import FooterSection from "../sections/FooterSection";
import type { Artwork } from "../types/artwork";

function Home() {
  const [featuredArtworks, setFeaturedArtworks] = useState<Artwork[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeaturedArtworks = async () => {
      try {
        setLoading(true);

        const response = await api.get("/artworks");

        const artworksData: Artwork[] = response.data;

        const featured = artworksData.filter(
          (artwork) => artwork.is_featured && !artwork.is_sold,
        );

        setFeaturedArtworks(featured.slice(0, 8));
      } catch (error) {
        console.error("Failed to load featured artworks:", error);
        setFeaturedArtworks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedArtworks();
  }, []);

  const organizationStructuredData: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Byzantine Art Studio",
    url: "https://byzantineartstudio.co.uk",
    logo: "https://byzantineartstudio.co.uk/images/byzantine-icon-logo.webp",
    description:
      "Byzantine Art Studio is an independent art studio producing hand-painted iconography for sale and by commission.",
    sameAs: ["https://byzantineartstudio.etsy.com"],
  };

  return (
    <Box>
      <SEO
        title="Hand-Painted Iconography"
        description="Unique hand-painted Byzantine iconography on wood, available as completed artworks or by commission."
        url="/"
        keywords="Byzantine Art Studio, hand-painted icons, Byzantine iconography, Orthodox icons, icons on wood"
        structuredData={organizationStructuredData}
      />

      <HeroSection />

      <FeaturedArtworksSection artworks={featuredArtworks} />

      <StudioSection />

      <CallToActionSection />

      <FooterSection />
    </Box>
  );
}

export default Home;
